import { Ba1300Class } from '../../ba1300/ba1300-class';
import { Ba4010Class } from '../../ba4010/ba4010-class';
import { Da1020Class } from '../../da1020/da1020-class';
import { Ba1160Class } from '../../ba1160/ba1160-class';
import { Ba1400Class } from '../../ba1400/ba1400-class';
import { Ba1700Class } from '../../ba1700/ba1700-class';
import { Da1030Class } from '../../da1030/da1030-class';
import { Da1510Class } from '../../da1510/da1510-class';
import { Da1500Class } from '../../da1500/da1500-class';
import { Da1430Class } from '../../da1430/da1430-class';
import { Da1120Class } from '../../da1120/da1120-class';
import { Ba1340Class } from '../../ba1340/ba1340-class';
import { Ba1320Class } from '../../ba1320/ba1320-class';
  
export class EmployeeListClass {
    TransactionDate: Date;
    EmployeeList:  Array<Ba1300Class> = [];
    EmployeeListSelected:  Array<Ba1300Class> = [];
    EmployeeStringListSelected:  string;
    PaygrpId: number;
    DeptId: number;
    DesgId: number;
    SpnsrId: number;
    BranchList:  Array<Ba4010Class> = [];
    PaygrpList:  Array<Da1020Class> = [];
    DeptList:  Array<Ba1160Class> = [];
    DesgIList:  Array<Ba1400Class> = [];
    SubDesignationList:  Array<Da1510Class> = [];
    SubDepartmentList:  Array<Da1500Class> = [];
    SponserList:  Array<Ba1700Class> = [];
    GradeList:  Array<Da1030Class> = [];
    CostCenterList:  Array<Da1430Class> = [];
    SalaryStructureList:  Array<Da1120Class> = [];
    NationalityList:  Array<Ba1340Class> = [];
    CurrencyList:  Array<Ba1320Class> = [];

    ActiveEmployeeFlag : number;
    SettlementFlag:number;
    ResignationFlag:number;
    ContractId:number;
    EmployeeNo:string;
    EmployeeName:string;
    OfficialDetailsId:number;
    contr_status_dtl_id:number;
    FkContractId:number;
    UpdateStatus:number;
    crtd_by:number;
    update_date:Date;
    comment:string;
    decision:string;
    contr_status_id:number
    Mode:number;
    ActiveFlag:number;
    FormatDtlId:number;
    FormatName:string;
    FormatDesc:string;
    FormatStatus:string;
    ReferenceNo:string;
    Notification:number;
    calenderId:number;
    Paycalid:number;
}
